import { broadcastLandrEvent, LandrEventType } from '@landr/core';
import {
    ArrowForwardOutlined,
    Button,
    Flex,
    Heading,
    Text,
} from '@landr/maestro';
import { Trans } from '@lingui/macro';
import React, { useCallback } from 'react';

export const StartDeviceAuthenticationStep: React.FC<{
    startDeviceAuthorization: () => void;
}> = ({ startDeviceAuthorization }) => {
    const startDeviceAuthentication = useCallback(() => {
        broadcastLandrEvent(LandrEventType.DeviceAuthorizationStart, undefined);
        startDeviceAuthorization();
    }, [startDeviceAuthorization]);

    return (
        <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
        >
            <Heading textStyle="4xl" textAlign="center">
                <Trans>Welcome to LANDR Samples</Trans>
            </Heading>
            <Text textAlign="center" color="text.medium">
                <Trans>We work for musicians</Trans>
            </Text>

            <Button
                isRounded
                iconRight={ArrowForwardOutlined}
                onClick={startDeviceAuthentication}
                mt="2xl"
            >
                <Trans>Get Started</Trans>
            </Button>
        </Flex>
    );
};
